import { notaFiscalInfo } from "../interfaces/notaFiscal/notaFiscalInfo";
import { notaFiscalProduto } from "../interfaces/notaFiscal/notaFiscalProduto";

interface parseNotaFiscalXmlFileContentResultType {
  tagsAreValid: boolean;
  productsArray: notaFiscalProduto[];
  informations: notaFiscalInfo | null;
}

export function parseNotaFiscalXmlFileContent(namespace: string, xmlFileContent: string): parseNotaFiscalXmlFileContentResultType {
  const xmlDocument = new DOMParser().parseFromString(xmlFileContent, "text/xml");
  const xmlDocumentProductElements = xmlDocument.getElementsByTagNameNS(namespace, "det");

  const cnpj = xmlDocument.getElementsByTagNameNS(namespace, "CNPJ")[0]?.textContent?.trim() || "";
  const xNome = xmlDocument.getElementsByTagNameNS(namespace, "xNome")[0]?.textContent?.trim() || "";
  const dhEmi = xmlDocument.getElementsByTagNameNS(namespace, "dhEmi")[0]?.textContent?.trim() || "";
  const nNf = xmlDocument.getElementsByTagNameNS(namespace, "nNF")[0]?.textContent?.trim() || "";

  let tagsAreValid = true;
  const productsArray: notaFiscalProduto[] = [];
  let informations: notaFiscalInfo | null = null;

  if (!cnpj || !xNome || !dhEmi || !nNf) {
    tagsAreValid = false;
  }

  for (let index = 0; index < xmlDocumentProductElements.length; index++) {
    const xmlProductTag = xmlDocumentProductElements[index].getElementsByTagNameNS(namespace, "prod")[0];

    if (!xmlProductTag) {
      tagsAreValid = false;
      break;
    }

    const cProd = xmlProductTag.getElementsByTagNameNS(namespace, "cProd")[0]?.textContent?.trim() || "";
    const cEAN = xmlProductTag.getElementsByTagNameNS(namespace, "cEAN")[0]?.textContent?.trim() || "";
    const xProd = xmlProductTag.getElementsByTagNameNS(namespace, "xProd")[0]?.textContent?.trim() || "";
    const uCom = xmlProductTag.getElementsByTagNameNS(namespace, "uCom")[0]?.textContent?.trim() || "";
    const qComStr = xmlProductTag.getElementsByTagNameNS(namespace, "qCom")[0]?.textContent?.replace(",", ".").trim() || "";

    const qCom = parseFloat(qComStr);

    if (!cProd || !xProd || !uCom || isNaN(qCom)) {
      tagsAreValid = false;
      break;
    }

    productsArray.push({
      cProd: cProd,
      cEAN: cEAN,
      xProd: xProd,
      uCom: uCom,
      qCom: qCom,
    });
  }

  if (tagsAreValid) {
    informations = {
      cnpj: cnpj,
      xNome: xNome,
      dhEmi: dhEmi,
      nNf: nNf,
    };
  }

  return {
    tagsAreValid,
    productsArray,
    informations,
  };
}

export function isPresentOnNotaFiscal(code: string, notaFiscalProductsArray: notaFiscalProduto[]): notaFiscalProduto | undefined {
  code = code.trim();
  let product: notaFiscalProduto | undefined;

  if (isEanBarcodeLength(code)) product = notaFiscalProductsArray.find((item) => item.cEAN === code);

  if (!product) product = notaFiscalProductsArray.find((item) => item.cProd === code);

  return product;
}

export function isEanBarcodeLength(text: string): boolean {
  const eanLengths = [0, 8, 12, 13, 14];
  const isEan = eanLengths.includes(text.trim().length);
  return isEan;
}

export function isSameProduct(firstItem: notaFiscalProduto, secondItem: notaFiscalProduto): boolean {
  return composeUniqueKey(firstItem) === composeUniqueKey(secondItem);
}

export function composeUniqueKey(item: notaFiscalProduto) {
  return `${item.cProd}-${item.cEAN}-${item.uCom}`;
}
